import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp, faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";

// הוק פשוט ומינימליסטי לאנימציית הופעה בגלילה
const useIntersectionObserver = (options = {}) => {
    const [isIntersecting, setIsIntersecting] = useState(false);
    const [element, setElement] = useState(null);

    useEffect(() => {
        if (!element) return;
        const observer = new IntersectionObserver(
            ([entry]) => setIsIntersecting(entry.isIntersecting),
            { threshold: 0.1, ...options }
        );
        observer.observe(element);
        return () => observer.disconnect();
    }, [element, options]);

    return [setElement, isIntersecting];
};

const ContactUs = () => {
    const [headerRef, headerVisible] = useIntersectionObserver();
    const [cardsRef, cardsVisible] = useIntersectionObserver();

    // הלוגיקה האמיתית והמדויקת שלך
    const contactConfig = {
        whatsapp: '+972559986085',
        email: 'bwdwtz417@gmail.com',
        phone: '055-998-6085',
        messages: {
            whatsapp: 'שלום, אני מעוניין ב',
            emailSubject: 'פנייה מהאתר',
            emailBody: 'שלום, אני מעוניין ב'
        }
    };

    const contactActions = {
        openWhatsApp: () => {
            const url = `https://wa.me/${contactConfig.whatsapp}?text=${encodeURIComponent(contactConfig.messages.whatsapp)}`;
            window.open(url, '_blank');
        },
        openEmail: () => {
            const url = `https://mail.google.com/mail/u/0/?view=cm&fs=1&to=${encodeURIComponent(contactConfig.email)}&su=${encodeURIComponent(contactConfig.messages.emailSubject)}&body=${encodeURIComponent(contactConfig.messages.emailBody)}`;
            window.open(url, '_blank');
        },
        openPhone: () => {
            window.open(`tel:${contactConfig.phone}`, '_blank');
        }
    };

    const socialLinks = [
        {
            icon: faFacebook,
            to: "https://www.facebook.com/profile.php?id=61556785871965",
            label: "עמוד הפייסבוק של פומה"
        },
        {
            icon: faInstagram,
            to: "https://www.instagram.com/pumawoodworking/",
            label: "עמוד האינסטגרם של פומה"
        }
    ];

    return (
        <section className="py-10 bg-surface border-t border-secondary/50" dir="rtl">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                {/* אזור כותרת - נקי, אדריכלי */}
                <div
                    ref={headerRef}
                    className={`text-center mb-10 transform transition-all duration-1000 ease-out ${headerVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}
                >

                    <h1 className="text-4xl md:text-5xl font-medium text-text-primary mb-6">
                        דברו איתנו
                    </h1>
                    <div className="w-16 h-1 bg-accent mx-auto rounded-full mb-6"></div>
                    <p className="text-lg text-text-secondary max-w-2xl mx-auto font-light">
                        נשמח לעמוד לשירותכם בכל שאלה, התייעצות או בקשה לפרויקט חדש.
                    </p>
                </div>

                {/* כרטיסיות יצירת קשר - Organic Luxury Style */}
                <div
                    ref={cardsRef}
                    className={`grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mb-20 max-w-5xl mx-auto transform transition-all duration-1000 ease-out delay-200 ${cardsVisible ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'}`}
                >
                    {/* כרטיסיית וואטסאפ */}
                    <div
                        onClick={contactActions.openWhatsApp}
                        className="group bg-background rounded-2xl p-8 flex flex-col items-center text-center cursor-pointer shadow-soft hover:shadow-hover border border-secondary/50 hover:border-accent/50 transition-all duration-300"
                        role="button"
                        tabIndex={0}
                    >
                        <div className="w-16 h-16 rounded-full bg-primary/5 flex items-center justify-center mb-6 group-hover:bg-primary group-hover:text-white transition-colors duration-300">
                            <FontAwesomeIcon icon={faWhatsapp} className="text-3xl text-primary group-hover:text-white transition-colors" />
                        </div>
                        <h3 className="text-xl font-medium text-text-primary mb-2">WhatsApp</h3>
                        <p className="text-text-secondary font-light">לחצו לשליחת הודעה ישירה</p>
                    </div>

                    {/* כרטיסיית טלפון */}
                    <div
                        onClick={contactActions.openPhone}
                        className="group bg-background rounded-2xl p-8 flex flex-col items-center text-center cursor-pointer shadow-soft hover:shadow-hover border border-secondary/50 hover:border-accent/50 transition-all duration-300"
                        role="button"
                        tabIndex={0}
                    >
                        <div className="w-16 h-16 rounded-full bg-primary/5 flex items-center justify-center mb-6 group-hover:bg-primary group-hover:text-white transition-colors duration-300">
                            <FontAwesomeIcon icon={faPhone} className="text-2xl text-primary group-hover:text-white transition-colors" />
                        </div>
                        <h3 className="text-xl font-medium text-text-primary mb-2">טלפון (צוריאל)</h3>
                        <p className="text-text-secondary font-light" dir="ltr">{contactConfig.phone}</p>
                    </div>

                    {/* כרטיסיית אימייל */}
                    <div
                        onClick={contactActions.openEmail}
                        className="group bg-background rounded-2xl p-8 flex flex-col items-center text-center cursor-pointer shadow-soft hover:shadow-hover border border-secondary/50 hover:border-accent/50 transition-all duration-300"
                        role="button"
                        tabIndex={0}
                    >
                        <div className="w-16 h-16 rounded-full bg-primary/5 flex items-center justify-center mb-6 group-hover:bg-primary group-hover:text-white transition-colors duration-300">
                            <FontAwesomeIcon icon={faEnvelope} className="text-2xl text-primary group-hover:text-white transition-colors" />
                        </div>
                        <h3 className="text-xl font-medium text-text-primary mb-2">אימייל</h3>
                        <p className="text-text-secondary font-light break-all">{contactConfig.email}</p>
                    </div>
                </div>

                {/* רשתות חברתיות */}
                <div className="text-center pt-10 border-t border-secondary">
                    <h3 className="text-lg font-medium text-text-primary mb-6">
                        עקבו אחרינו ברשתות החברתיות
                    </h3>
                    <div className="flex justify-center gap-6">
                        {socialLinks.map((social, index) => (
                            <a
                                key={index}
                                href={social.to}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={social.label}
                                className="w-12 h-12 rounded-full border border-secondary-dark flex items-center justify-center text-text-secondary hover:bg-primary hover:text-white hover:border-primary transition-all duration-300 shadow-sm"
                            >
                                <FontAwesomeIcon icon={social.icon} className="text-2xl" />
                            </a>
                        ))}
                    </div>
                </div>

            </div>
        </section>
    );
};

export default ContactUs;